import { SEARCH } from '@/config'
import { COMPANY_LP, JOB_LP, JOBS_GENERIC_LP } from '@/page/constants'
import { DEFAULT_NEXT_PARAMS } from '@/results/store/defaultState'
import { defaultType } from '@/search/store/defaultState'

export default (
  {
    page: {
      type: pageType
    } = {},
    results = {}
  } = {}
) => {
  const type = Object.keys(results).pop() || defaultType
  const {
    orderOptions,
    resultParams = {},
    result: list,
    resultSize: totalSize,
    resultSizeHighQuality: highQualitySize,
    resultSizeLowQuality: lowQualitySize
  } = results[type] || {}
  const { offset: initialOffset = 0 } = resultParams

  // Helpful exception during development
  if (process.env.NODE_ENV !== 'production' && type != null && SEARCH.types[type] == null) {
    throw new Error(`Using ${type} search type without specifying in CONTEXT.SEARCH.types! Available ${Object.keys(SEARCH.types).join(', ')}`)
  }

  const pageBasedDefaultNextParams = {}
  if ([JOB_LP, COMPANY_LP, JOBS_GENERIC_LP].includes(pageType)) {
    pageBasedDefaultNextParams.include_snippet = '1'
  }

  const hasMultiplePages = initialOffset > 0

  return {
    hasMultiplePages,
    highQualitySize,
    list,
    lowQualitySize,
    nextParams: type == null
      ? DEFAULT_NEXT_PARAMS
      : {
          ...pageBasedDefaultNextParams,
          ...SEARCH.types[type].paging,
          ...resultParams,
          offset: initialOffset + (list == null ? 0 : list.length),
          type,
          ...SEARCH.types[type].params
        },
    orderOptions,
    searchParams: {
      ...resultParams,
      type
    },
    totalSize,
    resultParams
  }
}
